module.exports = __webpack_public_path__ + "img/34.c7a39a69.jpg";